export default {
  table: {
    sortByColumn: 'Ordenar por {{column}}',
  },
  clipboard: {
    copyToClipboard: {
      success: 'Copiado para área de transferência.',
      error: 'Não foi possível copiar. Tente novamente.',
    },
  },
};
